/**
 * @usage Extend, do not use directly
 * @warn CANNOT HANDLE BEARER/AUTHORIZATION
 * @todo allow for shimming in extra headers when auth is needed
 */
export abstract class APIHelpers {
  protected baseUrl: string;

  protected getHeaders(): { Accept: string; 'Content-Type'?: string } {
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
  }

  protected fetch(
    path: string,
    options: RequestInit = {},
    query?: string | string[][] | Record<string, string> | URLSearchParams,
  ): Promise<any> { // eslint-disable-line
    return this.sendRequest(path, options, 'GET', query);
  }

  /**
   * @dev Same as this.fetch, but with a default timeout of 2 seconds
   */
  protected fetchWithTimeout(
    path: string,
    options: RequestInit = {},
    query?: string | string[][] | Record<string, string> | URLSearchParams,
    timeout = 2000,
  ): Promise<any> { // eslint-disable-line
    return Promise.race([
      this.sendRequest(path, options, 'GET', query),
      new Promise<Response>((_, reject) => setTimeout(() => reject(new Error('timeout')), timeout)),
    ]);
  }

  protected patch(
    path: string,
    options: RequestInit = {},
    query?: string | string[][] | Record<string, string> | URLSearchParams,
  ): Promise<any> { // eslint-disable-line
    return this.sendRequest(path, options, 'PATCH', query);
  }

  protected post(
    path: string,
    options: RequestInit = {},
    query?: string | string[][] | Record<string, string> | URLSearchParams,
  ): Promise<any> { // eslint-disable-line
    return this.sendRequest(path, options, 'POST', query);
  }

  protected delete(
    path: string,
    options: RequestInit = {},
    query?: string | string[][] | Record<string, string> | URLSearchParams,
  ): Promise<any> { // eslint-disable-line
    return this.sendRequest(path, options, 'DELETE', query);
  }

  async sendRequest(
    path: string,
    options: RequestInit = {},
    method: string,
    query?: string | string[][] | Record<string, string> | URLSearchParams,
  ): Promise<any> { // eslint-disable-line
    try {
      let url = this.baseUrl + path;

      if (query) {
        const queryString = new URLSearchParams(query).toString();
        url = url + '?' + queryString;
      }

      const requestOptions = {
        method: method,
        headers: this.getHeaders(),
        ...options,
      };

      const response = await fetch(url, requestOptions);
      if (!response.ok) {
        throw response;
      }
      let result;
      try {
        result = await response.text();
        return JSON.parse(result);
      } catch (e) {
        return result;
      }
    } catch (error: any) { // eslint-disable-line
      let response = error;
      try {
        response = await response.text();
        throw JSON.parse(response);
      } catch (e) {
        throw response;
      }
    }
  }
}
